import React from 'react';
import { ScrollImageComparison } from '../ui/scroll-image-comparison';
import { useStore } from '../../context/StoreContext';

const Experience = () => {
  const { landingSettings } = useStore();
  
  // Extract images from store or fallback
  const beforeImage = landingSettings?.find(s => s.setting_key === 'exp_before')?.image_url || "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782457517/Home_page_pic_1_idncqw.jpg";
  const afterImage = landingSettings?.find(s => s.setting_key === 'exp_after')?.image_url || "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782313478/2_tck6ul.png";

  return (
    <ScrollImageComparison 
      beforeImage={beforeImage} 
      afterImage={afterImage}
    >
      <div className="bg-black/40 backdrop-blur-md p-8 md:p-12 rounded-3xl border border-white/20 text-center max-w-4xl mx-auto shadow-2xl">
        <h2 className="text-3xl md:text-5xl font-serif text-white mb-6 uppercase tracking-wide">
          True Ceylon<br/>Cinnamon Experience
        </h2>
        <p className="text-white/90 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          Experience the finest authentic cinnamon from our estates, carefully selected and prepared to preserve its delicate flavor and aroma. Our commitment to sustainable sourcing ensures that every product you receive directly supports local communities and preserves the natural beauty of Ceylon.
        </p>
      </div>
    </ScrollImageComparison>
  );
};

export default Experience;